// Framework and Local Storage imports
import _ from 'ext:lodash';
import Framework from 'framework';
import Cookies from 'cookies-js';
import constants from 'lib/constants';
import profileStore from 'framework/stores/ProfileStore';
import localStorage from 'lib/local-storage';
import sessionStorage from 'lib/session-storage';

function trackSignInOutEvents() {
	// check for sign-in/out objects in local storage
	var userSignedIn = localStorage.get('userSignedIn');
	var userSignedOut = localStorage.get('userSignedOut');
	if(userSignedOut){
		Framework.actions.collectAnalytics({
			user: {loginStatus: 'logged out'},
			event: 'User Signed Out'
			});
		// releasing sing-out object from local storage, since event was collected
		localStorage.remove('userSignedOut');
	}else{
		if(userSignedIn) {
			Framework.actions.collectAnalytics({
				user: {loginStatus: 'logged in'},
				event: 'User Signed In'
				});
			// releasing sing-in object from local storage, since event was collected
			localStorage.remove('userSignedIn');
		}
	}
}

function trackPageUserLocInfo() {

	function getCorporateInfo() {
		const storedPromotionInfo = Cookies.get(constants.cookieCorpMembership);
		let corpDisplayName = '';
		if(storedPromotionInfo !== null && typeof storedPromotionInfo !== 'undefined' && storedPromotionInfo.length > 0) {
			corpDisplayName = storedPromotionInfo.split('|')[1] ? storedPromotionInfo.split('|')[1] : '';
		}
		return corpDisplayName;
	}

	function getNestedObject(e, t) {
		var pathArr = t.split('.');
		return pathArr.reduce(function(a, b) {
			return a && a[b] !== 'undefined' ? a[b] : void 0;
		}, e);
	}
	function getEnv() {
		return /\.app/.test(location.pathname) ? 'hma' : 'web';
	}
	function getExperience() {
		var experiences = [{host: 'www.lifetime.life', exp: 'prospect'},
			{host: 'my.lifetime.life', exp: 'member'},
			{host: 'join.lifetime.life', exp: 'oms'},
			{host: 'work.lifetime.life', exp: 'work'},
			{host: 'shop.lifetime.life', exp: 'shop'},
			{host: 'swim.lifetime.life', exp: 'swim'},
			{host: 'sport.lifetime.life', exp: 'sport'},
			{host: 'living.lifetime.life', exp: 'living'}];
		var foundedExp = _.find(experiences, (e) => {
			return location.hostname.indexOf(e.host) > -1;
		});
		return foundedExp ? foundedExp.exp : 'other';
	}
	function getPageType() {
		const path = location.pathname;
		const pageTypeRegExes = [{regex: /\/(sports-programs|training-types|health-wellness|fitness-classes|spa|cafe|kids-family-fun|outdoor-pools|active-events)\//,	type: 'company-inside'},
			{regex: /\/services\//, type: 'services'},
			{regex: /\/programs\//, type: 'programs'},
			{regex: /\/classes\//, type: 'classes'},
			{regex: /\/events\//, type: 'events'},
			{regex: /\/(checkout\/|cart)/, type: 'checkout'},
			{regex: /\/c\//, type: 'category'},
			{regex: /\/p\//, type: 'product'},
			{regex: /\/(account([\/.])|login|autoship$)/, type: 'account'},
			{regex: /\/((life-time-locations|search|locate-a-club)[^\/]*\.html)/, type: 'search'},
			{regex: /\/((clubs|locations|life-time-locations).*)\//, type: 'location'},
			{regex: /\/(ltfoms(\/|$)|(join|build-and-price)(\/|\.(html|offer))|create-account\.)/, type: 'form'},
			{regex: /^\/((home|index)\.html)?$/i, type: 'homepage'}];
		for(let pageTypeRegEx of pageTypeRegExes) {
			if(pageTypeRegEx.regex.test(path)) {
				return pageTypeRegEx.type;
			}
		}
		return 'information';
	}

	function trimUnwantedChars(path) {
		return path.replace(/(\.app)?(\.html)?/gi, '').replace(/([-\/.])/gi, ' ');
	}

	function isClubHomePage() {
		const path = location.pathname;
		return !!(window.lt && window.lt.club && ((window.lt.club.clubPagePath && path.includes(window.lt.club.clubPagePath)) ||
			(window.lt.club.clubPagePaths && window.lt.club.clubPagePaths.clubHome && path.includes(window.lt.club.clubPagePaths.clubHome))));
	}

	function getPageCategory(pageType) {
		let pageCategory;
		if(isClubHomePage()) {
			pageCategory = 'club home';
		} else if(pageType === 'homepage') {
			pageCategory = 'home';
		} else{
			pageCategory = _.last(_.without(location.pathname.split('/'), '')) || 'not defined';
		}
		pageCategory = trimUnwantedChars(pageCategory);
		return pageCategory.toLowerCase();
	}

	function getPageSubsection(pageType) {
		let pageCategory;
		if(pageType === 'homepage') {
			pageCategory = 'home';
		} else{
			pageCategory = _.first(_.without(location.pathname.split('/'), '')) || 'not defined';
		}
		pageCategory = trimUnwantedChars(pageCategory);
		return pageCategory.toLowerCase();
	}

	function getPageStatusCode() {
		let statusCode = '200';
		const pageTitle = document.title;

		if(pageTitle.indexOf('Error') >= 0 || pageTitle.indexOf('CI Unavailable') >= 0) {
			if(pageTitle.indexOf('Internal Server Error') >= 0) {
				statusCode = '500';
			} else if(pageTitle.indexOf('Coming Back Soon') >= 0) {
				statusCode = '503';
			} else if(pageTitle.indexOf('CI Unavailable') >= 0 || pageTitle.indexOf('CI Internal Error') >= 0) {
				statusCode = '404';
			} else if(pageTitle.indexOf('Page Not Found') >= 0) {
				switch(location.pathname){
					case '/error/corporate-memberships.html':
						statusCode = '410';
						break;
					case '/error/referral.html':
						statusCode = '410';
						break;
					case '/error/lead.html':
						statusCode = '503';
						break;
					default:
						statusCode = '404';
				}
			} else if(pageTitle === 'Error') {
				statusCode = document.querySelectorAll('strong')[1].textContent;
			}
		}
		return statusCode;
	}

	function getPageInfo() {
		var siteType = getEnv(),
			siteName = getExperience(),
			pageType = getPageType(),
			subsection = getPageSubsection(pageType),
			pageCategory = getPageCategory(pageType),
			statusCode = getPageStatusCode();
		return {
			page: {
				subsection: subsection,
				siteType: siteType,
				siteName: siteName,
				pageType: pageType,
				pageName: [siteName, pageType, pageCategory].join(':'),
				pageCategory: pageCategory,
				statusCode: statusCode
			},
			event: 'Page Loaded'
		};
	}

	function isLocationDetailPage() {
		return window.lt && window.lt.pageProperties && window.lt.pageProperties.club && !0 === window.lt.pageProperties.club;
	}

	function getUserInfo() {
		function getProspectUserInfo() {
			const corpDisplayName = getCorporateInfo();
			return {
				user: {
					companyName: corpDisplayName
				}
			};
		}
		function getMemberUserInfo(profileData) {
			let localStorageLtfMember = localStorage.get('ltf-member') || {},
				memberState = getNestedObject(profileData, 'memberState');
			memberState = memberState || (localStorageLtfMember.firstName ? 'AUTHENTICATED' : '');
			// identify if user is from a corporate partner
			const corpDisplayName = getCorporateInfo();
			// pull in partner program if available
			let partnerProgramObj = {};
			const programArray = getNestedObject(profileData, 'memberDetails.partnerPrograms') || localStorageLtfMember.partnerPrograms;
			if (programArray && programArray.length > 0) {
				partnerProgramObj.enrollmentDate = programArray[0].enrollmentDate;
				partnerProgramObj.enrollmentId = programArray[0].enrollmentId;
				partnerProgramObj.programId = programArray[0].programId;
				partnerProgramObj.terminationDate =programArray[0].terminationDate;
			}

			return {
				user: {
					loginStatus: memberState !== 'UNKNOWN' ? memberState : 'unauthenticated',
					memberId: getNestedObject(profileData, 'memberDetails.memberId') || localStorageLtfMember.memberId,
					partyId: getNestedObject(profileData, 'partyId'),
					entityId: '<entityId>',
					employeeId: '<employeeId>',
					recentClubsCount: (getNestedObject(profileData, 'personalization.recentClubs') || '').length,
					membershipStatus: getNestedObject(profileData, 'memberDetails.membershipStatus') || localStorageLtfMember.membershipStatus,
					accountIsActive: getNestedObject(profileData, 'memberDetails.active') || localStorageLtfMember.active,
					ltBucksBalance: getNestedObject(profileData, 'memberDetails.ltBucksBalance') || localStorageLtfMember.ltBucksBalance,
					ltBucksDetails: getNestedObject(profileData, 'memberDetails.ltBucksDetails') || localStorageLtfMember.ltBucksDetails,
					clubVisits: getNestedObject(profileData, 'memberDetails.clubVisits') || localStorageLtfMember.clubVisits,
					guestPassBalance: getNestedObject(profileData, 'memberDetails.guestPassBalance') || localStorageLtfMember.guestPassBalance,
					guestPassPeriod: getNestedObject(profileData, 'memberDetails.guestPassPeriod') || localStorageLtfMember.guestPassPeriod,
					guestPassTotal: getNestedObject(profileData, 'memberDetails.guestPassTotal') || localStorageLtfMember.guestPassTotal,
					memberType: getNestedObject(profileData, 'memberDetails.memberType') || localStorageLtfMember.memberType,
					membershipId: getNestedObject(profileData, 'memberDetails.membershipId') || localStorageLtfMember.membershipId,
					membershipLevelId: getNestedObject(profileData, 'memberDetails.membershipLevelId') || localStorageLtfMember.membershipLevelId,
					membershipLevel: getNestedObject(profileData, 'memberDetails.membershipLevel') || localStorageLtfMember.membershipLevel,
					membershipLevelGroupId: getNestedObject(profileData, 'memberDetails.membershipLevelGroupId') || localStorageLtfMember.membershipLevelGroupId,
					membershipLevelGroupName: getNestedObject(profileData, 'memberDetails.membershipLevelGroupName') || localStorageLtfMember.membershipLevelGroupName,
					partnerProgram: partnerProgramObj,
					roles: _.join((getNestedObject(profileData, 'memberDetails.roles') || localStorageLtfMember.roles), '|'),
					homeClubId: getNestedObject(profileData, 'memberDetails.homeClubId') || localStorageLtfMember.homeClubId,
					isEmployee: getNestedObject(profileData, 'memberDetails.isEmployee') || localStorageLtfMember.isEmployee,
					joinDate: getNestedObject(profileData, 'memberDetails.joinDate') || localStorageLtfMember.joinDate,
					availableClubsCount: getNestedObject(profileData, 'memberDetails.availableClubsCount') || (localStorageLtfMember.availableClubs || '').length,
					membershipJoinSource: getNestedObject(profileData, 'memberDetails.membershipJoinSource') || localStorageLtfMember.membershipJoinSource,
					membershipTypeAttributes: getNestedObject(profileData, 'memberDetails.membershipTypeAttributes') || localStorageLtfMember.membershipTypeAttributes,
					companyName: corpDisplayName
				},
				event: 'User Detected'
			};
		}

		if(Framework.global.lt.pageProperties.experienceType !== constants.experienceTypeMember && Framework.global.lt.pageProperties.experienceType !== constants.experienceTypeWork) {
			return Promise.resolve(getProspectUserInfo());
		} else{
			const initialData = window.ef.profileStore.getInitialData();
			//if ProfileStore already initialized -> resolve it immediately
			//as well as when experience == 'prospect', since in this case ProfileStore will never be initialized
			if(initialData && initialData.initialized) {
				return Promise.resolve(getMemberUserInfo(initialData));
			} else{
				return new Promise((resolve) => {
					window.ef.profileStore.listen((profileData) => {
						resolve(getMemberUserInfo(profileData));
					});
				});
			}
		}
	}
	function getLocationInfo() {
		if(!isLocationDetailPage()){
			return {};
		}
		return {
			lifeTimeLocation: [{
				locationName: window.lt.club.marketingClubName,
				locationID: 'LL_' + window.lt.club.mmsClubId,
				locationStatus: [window.lt.club.open, window.lt.club.oms, window.lt.club.webFreePass].join('::'),
				isLocationDetailPage: !0
			}],
			event: 'Location Info Detected'
		};
	}

	function getSpaDetail() {
		const lifeSpaSlot = sessionStorage.get('lt-lifespa-slot');
		if(_.isEmpty(lifeSpaSlot)){
			return {};
		}
		return {
			spaDetails: [{
				spaName: lifeSpaSlot.serviceCategory + ' - ' + lifeSpaSlot.serviceName,
				spaID: 'SPA_' + lifeSpaSlot.serviceId
			}],
			event: 'Spa Detail Detected'
		};
	}

	const spaDetail = getSpaDetail(); //returns payload for "Spa Detail Detected"
	const locationInfo = getLocationInfo(); //returns payload for "Location Info Detected"
	const userInfo = getUserInfo(); //returns payload for "User Detected"
	const pageInfo = getPageInfo(); //returns payload for "Page Loaded"
	// Since returned values will be in order of the Promises passed - "pageInfo" should be the last one to
	// fire other events before "Page Loaded"
	Promise.all([spaDetail, locationInfo, userInfo, pageInfo]).then(values => {
		values.forEach((payload) => {
			if(!_.isEmpty(payload)) {
				Framework.actions.collectAnalytics(payload);
			}
		});
	});
}

export default {
	trackEvents() {
		trackPageUserLocInfo();
		trackSignInOutEvents();
	}
};
